import { DailyEffortsPresenter } from '@/presentation/presenters/dashboard/dailyEffortsPresenter'
import { StatisticsViewModel } from '@/presentation/viewmodels/dashboard/statisticsViewModel'

export function useDailyEffortsPresenter(
  presenter: DailyEffortsPresenter = new DailyEffortsPresenter(new StatisticsViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    initChart: presenter.initChart.bind(presenter)
  }
}
